// extracted by mini-css-extract-plugin
export default {"gradientText":"GradientTitle_gradientText__oWq7M","gradientTextLight":"GradientTitle_gradientTextLight__i-U5G"};